import { useMemo } from 'react'
import { ToolbarActionType } from 'Core/Workbench.ts'
import classes from './ActionsContainer.module.less'
import { ContainerType, TaskConfigType } from 'Types/Tasks.types'
import { DropdownActions } from 'Layouts/Workbench/ActionsContainer/DropdownActions/DropdownActions'
import { CollapsedActions } from 'Layouts/Workbench/ActionsContainer/CollpasedActions/CollpasedActions'
import { ExpandedActions } from 'Layouts/Workbench/ActionsContainer/ExpandedActions/ExpandedActions'

export type ActionsContainerProps = {
    actions: ToolbarActionType[]
    taskConfig: TaskConfigType<ContainerType, unknown>
}

export const ActionsContainer: React.FC<ActionsContainerProps> = (props: ActionsContainerProps) => {
    const { expandedActions, collapsedActions, dropdownActions } = useMemo(() => {
        const expandedActions = props.actions.filter(
            action => !action.isCollapsed && action.type === 'button'
        )
        const collapsedActions = props.actions.filter(action => action.isCollapsed)
        const dropdownActions = props.actions.filter(action => action.type === 'dropdown')
        return { expandedActions, collapsedActions, dropdownActions }
    }, [props.actions])

    return (
        <div className={classes.actionsContainer} data-testid="action-container">
            <DropdownActions dropdownActions={dropdownActions} />
            <CollapsedActions collapsedActions={collapsedActions} taskConfig={props.taskConfig} />
            <ExpandedActions expandedActions={expandedActions} />
        </div>
    )
}
